import React from 'react'
import "./Navbar.css";

function Hamburger() {
  return (

    <div className='hamgurger-icon'>
 <svg viewBox="0 0 100 80" width="40" height="40">
        <rect width="100" height="10"/>
        <rect y="30" width="100" height="10"/>
        <rect y="60" width="100" height="10"/>
    </svg>

    </div>

  )
}

export default Hamburger
